<!-- src/app/tripist/documents-edit/documents-edit.component.html -->
<div class="header-bar">
    <div class="header-left"></div>
    <div class="header-center">
      {{ newDocument ? createItemText : editItemText }}
    </div>
  
    <div *ngIf="newDocument" class="header-right">
      <button mat-button color="fiord" (click)="cancel()">Cancel</button>
      <button mat-button color="lightGreen" (click)="saveNewDocument()" [disabled]="saveDisabled">
        {{ saveNewItemText }}
      </button>
    </div>
  
    <div *ngIf="!newDocument" class="header-right">
      <button
        mat-button
        color="warn"
        *ngIf="canClearMockBookings"
        (click)="clearMockBookings()"
      >
        Clear Mock Booking Data
      </button>
      <button mat-button color="warn" (click)="deleteDocument()">{{ deleteItemText }}</button>
      <button mat-button color="lightGreen" (click)="saveDocumentUpdates()" [disabled]="saveDisabled">
        {{ saveItemUpdatesText }}
      </button>
    </div>
  </div>
  
  <div class="category">
    <div class="containers">
      <div class="left-column">
        <!-- Document Details Container -->
        <div class="container document-details-container">
          <div class="container-header no-bottom-border">
            <div class="text">{{ itemDetailsText }}</div>
          </div>
          <div class="container-content">
            <div class="container-row">
              <lhpe-input class="input"
                          controlName="name"
                          placeholder="Name"
                          [formGroup]="documentForm"
                          [required]="true"
                          [maxlength]="128">
              </lhpe-input>
            </div>
            <div class="container-row">
              <lhpe-input class="input"
                          controlName="subtitle"
                          [placeholder]="subtitleLabel"
                          [formGroup]="documentForm"
                          [required]="true"
                          [maxlength]="128">
              </lhpe-input>
            </div>
            <div class="container-row">
              <lhpe-textarea class="input"
                             controlName="preview"
                             placeholder="Preview"
                             [formGroup]="documentForm"
                             [rows]="3"
                             [required]="true"
                             [maxlength]="256">
              </lhpe-textarea>
            </div>
            <div class="container-row">
              <lhpe-textarea class="input"
                             controlName="content"
                             placeholder="Content"
                             [formGroup]="documentForm"
                             [required]="true"
                             [rows]="6">
              </lhpe-textarea>
            </div>
            <div class="container-row">
              <lhpe-input class="input"
                          controlName="url"
                          placeholder="URL"
                          [formGroup]="documentForm">
              </lhpe-input>
            </div>
            <div class="container-row">
              <mat-form-field>
                <mat-label>Booking Engine Integration</mat-label>
                <mat-select [formControl]="$any(documentForm.get('booking_engine_integration_id'))">
                  <mat-option [value]="null">None</mat-option>
                  <mat-option *ngFor="let integration of bookingEngineIntegrations" [value]="integration.id">
                    {{ integration.provider?.name }} ({{ integration.id }})
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="container-row">
              <lhpe-input class="input"
                          controlName="foreign_key"
                          placeholder="Foreign Key"
                          hint="Identity in external system"
                          [formGroup]="documentForm"
                          [required]="isBookingEngineSelected">
              </lhpe-input>
            </div>
            <div class="container-row mock-prompt-inspector-row" *ngIf="!newDocument && isMockBookingEngineSelected">
              <div class="mock-prompt-inspector-layout">
                <div class="mock-prompt-column">
                  <lhpe-textarea class="input"
                                 controlName="mock_data_prompt"
                                 placeholder="Mock Data Prompt"
                                 [formGroup]="documentForm"
                                 [rows]="5">
                  </lhpe-textarea>
                  <button
                    mat-button
                    color="lightGreen"
                    class="mock-generate-btn"
                    [disabled]="generateMockDataDisabled"
                    (click)="generateMockBookingData()"
                  >
                    {{ isGeneratingMockData ? 'Generating...' : 'Generate Mock Booking Data' }}
                  </button>
                </div>
                <div class="mock-inspector-column">
                  <div class="mock-inspector-header">Mock Data</div>
                  <div class="mock-inspector-subtext" *ngIf="hasStaleMockDataPreview">
                    Preview is out of date for this prompt. Generate mock booking data to refresh.
                  </div>

                  <div class="mock-empty-state" *ngIf="!hasGeneratedMockData">
                    No generated mock data yet. Use "Generate Mock Booking Data" to preview options.
                  </div>

                  <div class="mock-empty-state" *ngIf="hasGeneratedMockData && !hasRenderableMockPayloads">
                    Generated mock data exists, but no renderable options/availability payloads were found.
                  </div>

                  <div class="mock-renderer" *ngIf="hasRenderableMockPayloads" [ngSwitch]="activeMockRendererType">
                    <ng-container *ngSwitchCase="'hotel'">
                      <div class="mock-section-title">Room Options</div>
                      <div class="mock-card-list" *ngIf="mockOptionsList.length > 0; else noHotelOptions">
                        <div class="mock-option-card" *ngFor="let option of mockOptionsList">
                          <div class="mock-option-name">{{ option?.name || option?.option_id }}</div>
                          <div class="mock-option-meta">{{ option?.description || 'No description' }}</div>
                          <div class="mock-option-meta">
                            Rate: {{ option?.currency || 'USD' }} {{ option?.nightly_rate != null ? option?.nightly_rate : (option?.amount_total != null ? option?.amount_total : 'n/a') }}
                          </div>
                          <div class="mock-option-meta">
                            Capacity: {{ option?.max_party_size != null ? option?.max_party_size : 'n/a' }} guests
                          </div>
                          <div class="mock-option-meta">
                            Total units: {{ option?.inventory_total != null ? option?.inventory_total : '-' }}
                          </div>
                        </div>
                      </div>
                      <ng-template #noHotelOptions>
                        <div class="mock-empty-inline">No room options returned.</div>
                      </ng-template>

                      <div class="mock-section-title">General Availability</div>
                      <div class="mock-option-meta">
                        Check-in: {{ mockAvailabilityPayload?.availability?.stay_window?.arrival_date || '-' }}
                      </div>
                      <div class="mock-option-meta">
                        Check-out: {{ mockAvailabilityPayload?.availability?.stay_window?.departure_date || '-' }}
                      </div>
                      <div class="mock-option-meta">
                        Timezone: {{ mockAvailabilityPayload?.availability?.timezone || '-' }}
                      </div>
                      <div class="mock-option-meta" *ngIf="mockOperatingDays.length > 0">
                        Operating days: {{ mockOperatingDays.join(', ') }}
                      </div>
                      <div class="mock-option-meta" *ngFor="let row of mockInventoryByOption">
                        {{ row.option_id }} total units: {{ row.total_units }}
                      </div>
                      <div class="mock-option-meta">
                        Check-in window: {{ mockAvailabilityPayload?.availability?.check_in_window_local?.start || '-' }} - {{ mockAvailabilityPayload?.availability?.check_in_window_local?.end || '-' }}
                      </div>
                      <div class="mock-empty-inline">Booked state is stored in mock bookings and not in this payload.</div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'restaurant'">
                      <div class="mock-section-title">Dining Options</div>
                      <div class="mock-card-list" *ngIf="mockOptionsList.length > 0; else noRestaurantOptions">
                        <div class="mock-option-card" *ngFor="let option of mockOptionsList">
                          <div class="mock-option-name">{{ option?.name || option?.option_id }}</div>
                          <div class="mock-option-meta">{{ option?.description || 'No description' }}</div>
                          <div class="mock-option-meta">Max party size: {{ option?.max_party_size != null ? option?.max_party_size : 'n/a' }}</div>
                          <div class="mock-option-meta">Total units: {{ option?.inventory_total != null ? option?.inventory_total : '-' }}</div>
                          <div class="mock-option-meta">Meals: {{ formatMealPeriods(option) }}</div>
                        </div>
                      </div>
                      <ng-template #noRestaurantOptions>
                        <div class="mock-empty-inline">No dining options returned.</div>
                      </ng-template>

                      <div class="mock-section-title">General Availability</div>
                      <div class="mock-option-meta">
                        Requested meal period: {{ mockRestaurantRequestedMealPeriod || '-' }}
                      </div>
                      <div class="mock-option-meta" *ngIf="mockRestaurantOfferedMealPeriods.length > 0">
                        Offered meal periods: {{ mockRestaurantOfferedMealPeriods.join(', ') }}
                      </div>
                      <div class="mock-slot-list" *ngIf="mockAvailabilitySlots.length > 0">
                        <div class="mock-slot-item" *ngFor="let slot of mockAvailabilitySlots">
                          <span>{{ slot?.option_id || 'option' }}: {{ slot?.start_at || '-' }}<span *ngIf="slot?.meal_period"> ({{ slot?.meal_period }})</span></span>
                          <span class="mock-availability-badge" [class.unavailable]="slot?.available === false">
                            {{ slot?.available === false ? 'Closed' : 'Open' }}
                          </span>
                        </div>
                      </div>
                      <div class="mock-option-meta" *ngFor="let row of mockRestaurantMealPeriodEntries">
                        {{ row.day }} meal windows —
                        breakfast: {{ row.breakfast.length > 0 ? row.breakfast.join(', ') : 'closed' }},
                        lunch: {{ row.lunch.length > 0 ? row.lunch.join(', ') : 'closed' }},
                        dinner: {{ row.dinner.length > 0 ? row.dinner.join(', ') : 'closed' }}
                      </div>
                      <div class="mock-option-meta" *ngFor="let entry of mockOperatingHoursEntries">
                        {{ entry.day }}: {{ entry.windows.length > 0 ? entry.windows.join(', ') : 'closed' }}
                      </div>
                      <div class="mock-option-meta" *ngFor="let row of mockCapacityByOption">
                        {{ row.option_id }} total units: {{ row.total_units }}
                      </div>
                      <div class="mock-empty-inline">Booked state is stored in mock bookings and not in this payload.</div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'services'">
                      <div class="mock-section-title">Service Options</div>
                      <div class="mock-card-list" *ngIf="mockOptionsList.length > 0; else noServicesOptions">
                        <div class="mock-option-card" *ngFor="let option of mockOptionsList">
                          <div class="mock-option-name">{{ option?.name || option?.option_id }}</div>
                          <div class="mock-option-meta">{{ option?.description || 'No description' }}</div>
                          <div class="mock-option-meta">
                            Duration: {{ option?.duration_minutes != null ? option?.duration_minutes : 'n/a' }} min
                          </div>
                          <div class="mock-option-meta">
                            Price: {{ option?.currency || 'USD' }} {{ option?.amount_total != null ? option?.amount_total : '-' }}
                          </div>
                          <div class="mock-option-meta">
                            Employees: {{ formatEmployeeNames(option) }}
                          </div>
                        </div>
                      </div>
                      <ng-template #noServicesOptions>
                        <div class="mock-empty-inline">No service options returned.</div>
                      </ng-template>

                      <div class="mock-section-title">General Availability</div>
                      <div class="mock-slot-list" *ngIf="mockAvailabilitySlots.length > 0">
                        <div class="mock-slot-item" *ngFor="let slot of mockAvailabilitySlots">
                          <span>
                            {{ slot?.option_id || 'option' }}{{ slot?.employee_id ? ' • ' + slot?.employee_id : '' }}:
                            {{ slot?.start_at || '-' }}
                          </span>
                          <span class="mock-availability-badge" [class.unavailable]="slot?.available === false">
                            {{ slot?.available === false ? 'Closed' : 'Open' }}
                          </span>
                        </div>
                      </div>
                      <div class="mock-option-meta" *ngFor="let entry of mockOperatingHoursEntries">
                        {{ entry.day }}: {{ entry.windows.length > 0 ? entry.windows.join(', ') : 'closed' }}
                      </div>
                      <div class="mock-option-meta" *ngFor="let schedule of mockEmployeeSchedules">
                        {{ schedule.employee_id }}: {{ schedule.days.length > 0 ? schedule.days.join(', ') : '-' }} @ {{ schedule.windows.length > 0 ? schedule.windows.join(', ') : '-' }}
                      </div>
                      <div class="mock-empty-inline">Booked state is stored in mock bookings and not in this payload.</div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'equipment'">
                      <div class="mock-section-title">Equipment Options</div>
                      <div class="mock-card-list" *ngIf="mockOptionsList.length > 0; else noEquipmentOptions">
                        <div class="mock-option-card" *ngFor="let option of mockOptionsList">
                          <div class="mock-option-name">{{ option?.name || option?.option_id }}</div>
                          <div class="mock-option-meta">{{ option?.description || 'No description' }}</div>
                          <div class="mock-option-meta">
                            Resource type: {{ option?.resource_type || '-' }}
                          </div>
                          <div class="mock-option-meta">
                            Daily rate: {{ option?.currency || 'USD' }} {{ option?.amount_per_day != null ? option?.amount_per_day : '-' }}
                          </div>
                          <div class="mock-option-meta">
                            Total units: {{ option?.inventory_total != null ? option?.inventory_total : '-' }}
                          </div>
                        </div>
                      </div>
                      <ng-template #noEquipmentOptions>
                        <div class="mock-empty-inline">No equipment options returned.</div>
                      </ng-template>

                      <div class="mock-section-title">General Availability</div>
                      <div class="mock-option-meta">
                        Rental start: {{ mockAvailabilityPayload?.availability?.rental_window?.start_at || '-' }}
                      </div>
                      <div class="mock-option-meta">
                        Rental end: {{ mockAvailabilityPayload?.availability?.rental_window?.end_at || '-' }}
                      </div>
                      <div class="mock-option-meta">
                        Rental days: {{ mockAvailabilityPayload?.availability?.rental_window?.rental_days != null ? mockAvailabilityPayload?.availability?.rental_window?.rental_days : '-' }}
                      </div>
                      <div class="mock-option-meta">
                        Timezone: {{ mockAvailabilityPayload?.availability?.timezone || '-' }}
                      </div>
                      <div class="mock-option-meta" *ngFor="let row of mockInventoryByOption">
                        {{ row.option_id }} total units: {{ row.total_units }}
                      </div>
                      <div class="mock-option-meta">
                        Selected option remaining: {{ mockAvailabilityPayload?.availability?.selected_option_status?.remaining_units != null ? mockAvailabilityPayload?.availability?.selected_option_status?.remaining_units : '-' }}
                      </div>
                      <div class="mock-empty-inline">Booked state is stored in mock bookings and not in this payload.</div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'events'">
                      <div class="mock-section-title">Event Options</div>
                      <div class="mock-card-list" *ngIf="mockOptionsList.length > 0; else noEventOptions">
                        <div class="mock-option-card" *ngFor="let option of mockOptionsList">
                          <div class="mock-option-name">{{ option?.name || option?.option_id }}</div>
                          <div class="mock-option-meta">{{ option?.description || 'No description' }}</div>
                          <div class="mock-option-meta">
                            Price per person: {{ option?.currency || 'USD' }} {{ option?.amount_per_person != null ? option?.amount_per_person : '-' }}
                          </div>
                          <div class="mock-option-meta" *ngIf="option?.start_at || option?.end_at">
                            Window: {{ option?.start_at || '-' }} → {{ option?.end_at || '-' }}
                          </div>
                        </div>
                      </div>
                      <ng-template #noEventOptions>
                        <div class="mock-empty-inline">No event options returned.</div>
                      </ng-template>

                      <div class="mock-section-title">Event Window</div>
                      <div class="mock-option-meta">
                        Starts: {{ mockAvailabilityPayload?.availability?.event_window?.start_at || '-' }}
                      </div>
                      <div class="mock-option-meta">
                        Ends: {{ mockAvailabilityPayload?.availability?.event_window?.end_at || '-' }}
                      </div>
                      <div class="mock-option-meta">
                        Inventory mode: {{ mockEventInventoryMode }}
                      </div>
                      <div class="mock-option-meta">
                        Max tickets: {{ mockEventMaxTickets != null ? mockEventMaxTickets : '-' }}
                      </div>
                      <div class="mock-option-meta">
                        Sold tickets: {{ mockEventSoldTickets != null ? mockEventSoldTickets : '-' }}
                      </div>
                      <div class="mock-option-meta">
                        Tickets remaining: {{ mockEventTicketsRemaining != null ? mockEventTicketsRemaining : '-' }}
                      </div>
                      <div class="mock-section-title">General Availability</div>
                      <div class="mock-empty-inline" *ngIf="mockEventInventoryMode === 'seated'">Seating inventory is configured here; booked seats are tracked in mock bookings.</div>
                      <div class="mock-empty-inline" *ngIf="mockEventInventoryMode !== 'seated'">General admission availability is driven by max/sold ticket capacity.</div>
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                      <div class="mock-section-title">Options Payload</div>
                      <pre class="mock-json">{{ mockOptionsPayload | json }}</pre>
                      <div class="mock-section-title">Availability Payload</div>
                      <pre class="mock-json">{{ mockAvailabilityPayload | json }}</pre>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <div class="container-row" *ngIf="isBookingEngineSelected && documentForm.get('foreign_key')?.hasError('required')">
              <div class="error-message">
                Foreign Key is required when a Booking Engine Integration is selected
              </div>
            </div>
            <div class="container-row">
              <mat-checkbox [formControl]="$any(documentForm.get('publish'))" (change)="onPublishChange($event)">
                Publish
              </mat-checkbox>
            </div>
            <div class="container-row" *ngIf="documentForm.get('publish')?.value">
              <lhpe-input class="input"
                          controlName="publish_start_date"
                          placeholder="Publish Start Date"
                          type="datetime-local"
                          [formGroup]="documentForm">
              </lhpe-input>
            </div>
            <div class="container-row" *ngIf="documentForm.get('publish')?.value">
              <lhpe-input class="input"
                          controlName="publish_end_date"
                          placeholder="Publish End Date"
                          type="datetime-local"
                          [formGroup]="documentForm">
              </lhpe-input>
            </div>
            <div class="container-row">
              <mat-checkbox [formControl]="$any(documentForm.get('always_include'))" (change)="onFeatureChange($event)">
                Feature
              </mat-checkbox>
            </div>
            <div class="container-row" *ngIf="documentForm.get('always_include')?.value">
              <lhpe-input class="input"
                          controlName="feature_start_date"
                          placeholder="Feature Start Date"
                          type="datetime-local"
                          [formGroup]="documentForm">
              </lhpe-input>
            </div>
            <div class="container-row" *ngIf="documentForm.get('always_include')?.value">
              <lhpe-input class="input"
                          controlName="feature_end_date"
                          placeholder="Feature End Date"
                          type="datetime-local"
                          [formGroup]="documentForm">
              </lhpe-input>
            </div>
            
            <!-- Validation error messages -->
            <div class="container-row" *ngIf="documentForm.errors?.alwaysIncludeRequired">
              <div class="error-message">
                You must check "Feature" to specify feature dates
              </div>
            </div>
            <div class="container-row" *ngIf="documentForm.errors?.featureEndDateBeforeStartDate">
              <div class="error-message">
                Feature end date must be after feature start date
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="right-column">
        <!-- PREVIEW IMAGE -->
        <div class="container image-container">
          <div class="container-header no-bottom-border">
            <div class="text">Preview Image</div>
          </div>
          <div class="container-content">
            <!-- Show selected media if one exists -->
            <div class="container-row" *ngIf="selectedMedia">
              <div class="selected-media">
                <span>Selected:</span>
                <img [src]="selectedMedia.url"
                     [alt]="selectedMedia.description"
                     width="50" />
                <span>{{ selectedMedia.description }}</span>
                <button mat-icon-button
                        color="warn"
                        aria-label="Remove selected media"
                        (click)="clearMedia()">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>

            <!-- Show search and upload sections only if no media is selected -->
            <ng-container *ngIf="!selectedMedia">
              <div class="container-row">
                <lhpe-input
                  class="input"
                  controlName="mediaSearch"
                  placeholder="Search Existing Media"
                  [formGroup]="documentForm"
                  [matAutocomplete]="mediaAuto"
                ></lhpe-input>
                <mat-autocomplete
                  #mediaAuto="matAutocomplete"
                  (optionSelected)="onMediaSelected($event.option.value)"
                >
                  <mat-option
                    *ngFor="let media of filteredMedias"
                    [value]="media"
                  >
                    {{ media.description }}
                  </mat-option>
                </mat-autocomplete>
              </div>

              <!-- Divider with "or" -->
              <div class="container-row divider-row">
                <div class="divider-line"></div>
                <span class="divider-text">or</span>
                <div class="divider-line"></div>
              </div>

              <!-- Upload section -->
              <div class="upload-section">
                  <lhpe-input
                    *ngIf="uploadFile"
                    class="input desc-input"
                    controlName="imageName"
                    placeholder="Image Name"
                    [formGroup]="documentForm"
                    [required]="true"
                  ></lhpe-input>

                  <ngx-file-drop
                    dropZoneLabel="Drop files here"
                    accept=".png,.jpg,.jpeg,.svg"
                    [directory]="false"
                    [multiple]="false"
                    (onFileDrop)="dropped($event)"
                  >
                    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                      <ng-container *ngIf="!uploadFile">
                        <button
                          mat-button
                          class="icon-btn upload-icon"
                          (click)="openFileSelector()"
                        >
                          <svg-icon src="assets/svg/image-upload.svg"></svg-icon>
                        </button>
                        <div class="">Drag and drop image here</div>
                        <div class="">- or -</div>
                        <div class="">click to browse files</div>
                      </ng-container>
                      <ng-container *ngIf="uploadFile">
                        <svg-icon
                          class="upload-icon"
                          src="assets/svg/image-upload.svg"
                        ></svg-icon>

                        <div class="img-name">
                          {{ uploadFile.name }}
                        </div>
                        <div class="">
                          {{ uploadImageWidth ? uploadImageWidth : "unknown" }}px x
                          {{ uploadImageHeight ? uploadImageHeight : "unknown" }}px
                        </div>
                        <div class="">{{ uploadFile.size | filesize }}</div>
                        <div class="cancel-btn" (click)="removeUploadFile()">Cancel</div>
                      </ng-container>
                    </ng-template>
                  </ngx-file-drop>

                  <div *ngIf="!uploadFile" class="optimal-size">
                    Optimal image size: px wide x px tall
                  </div>
                  <div class="button-row" *ngIf="uploadFile">
                    <button
                      mat-button
                      color="lightGreen"
                      [disabled]="uploadDisabled"
                      (click)="uploadImage()"
                    >
                      Upload image
                    </button>
                    <button mat-button color="fiord" (click)="removeUploadFile()">
                      Cancel
                    </button>
                  </div>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- HERO IMAGE -->
        <div class="container image-container">
          <div class="container-header no-bottom-border">
            <div class="text">Hero Image</div>
          </div>
          <div class="container-content">
            <div class="container-row" *ngIf="selectedHeroMedia">
              <div class="selected-media">
                <span>Selected:</span>
                <img [src]="selectedHeroMedia.url"
                     [alt]="selectedHeroMedia.description"
                     width="50" />
                <span>{{ selectedHeroMedia.description }}</span>
                <button mat-icon-button
                        color="warn"
                        aria-label="Remove selected hero media"
                        (click)="clearHeroMedia()">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>

            <ng-container *ngIf="!selectedHeroMedia">
              <div class="container-row">
                <lhpe-input
                  class="input"
                  controlName="heroMediaSearch"
                  placeholder="Search Existing Hero Media"
                  [formGroup]="documentForm"
                  [matAutocomplete]="heroMediaAuto"
                ></lhpe-input>
                <mat-autocomplete
                  #heroMediaAuto="matAutocomplete"
                  (optionSelected)="onHeroMediaSelected($event.option.value)"
                >
                  <mat-option
                    *ngFor="let media of filteredHeroMedias"
                    [value]="media"
                  >
                    {{ media.description }}
                  </mat-option>
                </mat-autocomplete>
              </div>

              <div class="container-row divider-row">
                <div class="divider-line"></div>
                <span class="divider-text">or</span>
                <div class="divider-line"></div>
              </div>

              <div class="upload-section">
                <lhpe-input
                  *ngIf="heroUploadFile"
                  class="input desc-input"
                  controlName="heroImageName"
                  placeholder="Hero Image Name"
                  [formGroup]="documentForm"
                  [required]="true"
                ></lhpe-input>

                <ngx-file-drop
                  dropZoneLabel="Drop files here"
                  accept=".png,.jpg,.jpeg,.svg"
                  [directory]="false"
                  [multiple]="false"
                  (onFileDrop)="heroDropped($event)"
                >
                  <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                    <ng-container *ngIf="!heroUploadFile">
                      <button
                        mat-button
                        class="icon-btn upload-icon"
                        (click)="openFileSelector()"
                      >
                        <svg-icon src="assets/svg/image-upload.svg"></svg-icon>
                      </button>
                      <div class="">Drag and drop image here</div>
                      <div class="">- or -</div>
                      <div class="">click to browse files</div>
                    </ng-container>
                    <ng-container *ngIf="heroUploadFile">
                      <svg-icon
                        class="upload-icon"
                        src="assets/svg/image-upload.svg"
                      ></svg-icon>

                      <div class="img-name">
                        {{ heroUploadFile.name }}
                      </div>
                      <div class="">
                        {{ heroUploadImageWidth ? heroUploadImageWidth : "unknown" }}px x
                        {{ heroUploadImageHeight ? heroUploadImageHeight : "unknown" }}px
                      </div>
                      <div class="">{{ heroUploadFile.size | filesize }}</div>
                      <div class="cancel-btn" (click)="removeHeroUploadFile()">Cancel</div>
                    </ng-container>
                  </ng-template>
                </ngx-file-drop>

                <div *ngIf="!heroUploadFile" class="optimal-size">
                  Optimal image size: px wide x px tall
                </div>
                <div class="button-row" *ngIf="heroUploadFile">
                  <button
                    mat-button
                    color="lightGreen"
                    [disabled]="heroUploadDisabled"
                    (click)="uploadHeroImage()"
                  >
                    Upload hero image
                  </button>
                  <button mat-button color="fiord" (click)="removeHeroUploadFile()">
                    Cancel
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- Categories & Keywords -->
        <div class="container category-details-container">
        <div class="container-header no-bottom-border">
          <div class="text">Categories & Keywords</div>
        </div>
        <div class="container-content">
          <!-- add‐category autocomplete -->
          <div class="container-row">
            <mat-form-field>
              <mat-label>Add Category</mat-label>
              <input matInput [formControl]="categorySelectControl" [matAutocomplete]="categoryAuto" />
              <mat-autocomplete #categoryAuto="matAutocomplete" (optionSelected)="onCategorySelected($event.option.value)">
                <mat-option *ngFor="let cat of filteredCategories" [value]="cat">
                  {{ cat.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <!-- primary category selector -->
          <div class="container-row" *ngIf="primaryCategoryOptions.length > 0">
            <mat-form-field>
              <mat-label>Primary Category</mat-label>
              <mat-select [formControl]="primaryCategoryControl" (selectionChange)="onPrimaryCategoryChange($event.value)">
                <mat-option value="">None</mat-option>
                <mat-option *ngFor="let ck of primaryCategoryOptions" [value]="ck.category.id">
                  {{ ck.category.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="container-row" *ngIf="hasAssignedCategories && !hasPrimaryCategoryAssigned">
            <div class="error-message">
              A primary category is required when categories are assigned.
            </div>
          </div>
  
          <!-- for each selected category: show chips + add‐tag input -->
          <ng-container *ngFor="let ck of categoryKeywords">
            <div class="container-row category-header-row">
              <strong>
                {{ ck.category.name }}
                <span *ngIf="ck.is_primary" class="primary-badge">PRIMARY</span>
              </strong>
              <button mat-icon-button color="warn"
                      aria-label="Remove category"
                      (click)="removeCategory(ck)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
            <div class="container-row">
              <mat-chip-list>
                <mat-chip *ngFor="let tag of getSortedTagsForCategory(ck)"
                          [removable]="true"
                          (removed)="removeTag(ck, tag)">
                  {{ tag }} <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              </mat-chip-list>
            </div>
            <div class="container-row">
              <mat-form-field>
                <input matInput 
                       placeholder="Add Tag for {{ ck.category.name }} (comma-separated for multiple)" 
                       [formControl]="newTagControls[ck.category.id]"
                       (keydown.enter)="$event.preventDefault(); addTag(ck)" />
                       
                <!-- Autocomplete suggestions dropdown -->
                <div class="tag-suggestions" *ngIf="getFilteredTagsForCategory(ck.category.id).length > 0">
                  <div class="suggestion-item" 
                       *ngFor="let tag of getFilteredTagsForCategory(ck.category.id)"
                       (click)="onTagSelected(ck, tag)">
                    {{ tag }}
                  </div>
                </div>
              </mat-form-field>
            </div>
            </ng-container>
        </div>
      </div>
      </div>
    </div>
  </div>